import { AbstractControl, ValidatorFn } from '@angular/forms';

export function numberValidator(min: number | null, max: number | null): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // Do not check if the formGroup has not been initialized yet
    if (!control.parent) {
      return null;
    }

    if (control.value && !/^\d+$/.test(control.value)) {
      return { numberOnly: true };
    }

    if (min && max && (control.value < min || control.value > max)) {
        return { numberInvalid: true };
    } else if (min && !max && control.value < min ) {
        return { numberInvalid: true };
    } else if (!min && max && control.value > max ) {
        return { numberInvalid: true };
    }

    return null;
  };
}
